import * as Pioneer from 'pioneer';

import globalRefs from '../managers/globalRefs';

/**
 * Load a local NISAR image from www/assets/ce2s2_nisar_data onto the earth patch.
 * Unlike gmaps, this does not prepend Config.baseCe2s2Url.
 * @param {object} nisarData
 */
const loadNisar = async nisarData => {
	const { pioneer } = globalRefs;
	const { image_src, north_boundary, south_boundary, east_boundary, west_boundary, transparent } = nisarData || {};

	const lowerLeftLLA = new Pioneer.LatLonAlt();
	const upperRightLLA = new Pioneer.LatLonAlt();
	const earth = pioneer.get('main', 'earth');
	const patchComponent = earth.getComponent(Pioneer.SpheroidLODComponent, 'patch');

	patchComponent.setRenderingEnabled(false);

	lowerLeftLLA.set(
		Pioneer.MathUtils.degToRad(parseFloat(south_boundary)),
		Pioneer.MathUtils.degToRad(parseFloat(west_boundary)),
		0,
		true
	);
	upperRightLLA.set(
		Pioneer.MathUtils.degToRad(parseFloat(north_boundary)),
		Pioneer.MathUtils.degToRad(parseFloat(east_boundary)),
		0,
		true
	);

	patchComponent.setMapping('cylinder');
	patchComponent.setTexture('color', image_src);
	patchComponent.setBounds(lowerLeftLLA, upperRightLLA);

	patchComponent.forceTextureSize('color', 0);
	patchComponent.setEnabled(true);

	const material = patchComponent._threeJsMaterials?.[0];
	if (material) {
		material.transparent = Boolean(transparent);
	}

	try {
		await earth.waitTillInPlace();
		await patchComponent.getLoadedPromise(true, 30);
	} catch (e) {
		console.warn('NISAR patch load failed: ', e);
	}

	patchComponent.setRenderingEnabled(true);
};

export {
	loadNisar
};
